export default __webpack_public_path__ + "images/95a3af3ed0d7ec57c64b88bb7fe1ad4c.jpg";